export default () =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}roles?per_page=100`)
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
